import { useStaticData } from '@mc/static-data-react'
import { SeriesAboutSection } from 'components/SeriesAboutSection'

import { EpisodeStaticData } from '../../[episodeSlug].page'

export const SeriesDetails = () => {
  const { course } = useStaticData<EpisodeStaticData>()

  return (
    <div className='mc-mb-12'>
      <SeriesAboutSection series={course} pageType='episode' />
    </div>
  )
}
